import slotTypePositionCalculator from "./positionCalculators/SlotTypePositionCalculator";
import conditionPositionCalculator from "./positionCalculators/ConditionPositionCalculator";
export var CONDITION_POSITION_CALCULATOR = 1;
export var SLOT_TYPE_POSITION_CALCULATOR = 2;
export default function positionCalculatorProvider(positionCalculatorType) {
    switch (positionCalculatorType) {
        case SLOT_TYPE_POSITION_CALCULATOR:
            return slotTypePositionCalculator;
        case CONDITION_POSITION_CALCULATOR:
            return conditionPositionCalculator;
        default:
            console.warn("Cannot find position calculator", positionCalculatorType);
            return undefined;
    }
}



// WEBPACK FOOTER //
// ./src/components/grid/slot-arrangement-policies/PositionCalculatorProvider.js